import Vue from "vue";
import VueRouter from "vue-router";

import Home from "./../pages/Home.vue";
import About from "./../pages/About.vue";
import TermsAndConditions from "./../pages/TermsAndConditions.vue";
import PrivacyPolicy from "./../pages/PrivacyPolicy.vue";
import CodeOfConduct from "./../pages/CodeOfConduct.vue";
import Partners from "./../pages/Partners.vue";

import Courses from "./../pages/Courses.vue";
import Teachers from "./../pages/Teachers.vue";
import Curricula from "./../pages/Curricula.vue";
import Register from "./../pages/Register.vue";
import FAQ from "./../pages/FAQ.vue";
import PrivateSchools from "./../pages/PrivateSchools.vue";

import HelloComputer from "./../pages/HelloComputer.vue";
import HelloWorld from "./../pages/HelloWorld.vue";
import HelloJavaScript from "./../pages/HelloJavaScript.vue";
import ReadyGoPlay from "./../pages/ReadyGoPlay.vue";

import DemoDay from "./../pages/DemoDay.vue";

import NotFound from "./../pages/404.vue";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  routes: [
    
     {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/",
      redirect: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      component: About,
      props: true
    },
    {
      path: "/terms-and-conditions",
      name: "TermsAndConditions",
      component: TermsAndConditions,
      props: true
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
      props: true
    },
    {
      path: "/code-of-conduct",
      name: "CodeOfConduct",
      component: CodeOfConduct,
      props: true
    },
    {
      path: "/partners",
      name: "Partners",
      component: Partners,
      props: true
    },
    {
      path: "/courses",
      name: "Courses",
      component: Courses,
      props: true
    },
    {
      path: "/curricula",
      name: "Curricula",
      component: Curricula,
      props: true
    },
    {
      path: "/private-schools",
      name: "PrivateSchools",
      component: PrivateSchools,
      props: true
    },
    {
      path: "/teachers",
      name: "Teachers",
      component: Teachers,
      props: true
    },
    {
      path: "/hello-computer",
      name: "HelloComputer",
      component: HelloComputer,
      props: true
    },
    {
      path: "/hello-world",
      name: "HelloWorld",
      component: HelloWorld,
      props: true
    },
    {
      path: "/hello-javascript",
      name: "HelloJavaScript",
      component: HelloJavaScript,
      props: true
    },
    {
      path: "/ready-go-play",
      name: "ReadyGoPlay",
      component: ReadyGoPlay,
      props: true
    },
    {
      path: "/demo-day",
      name: "DemoDay",
      component: DemoDay,
      props: true
    },
    {
      path: "/faq",
      name: "FAQ",
      component: FAQ,
      props: true
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      props: true
    },
    { 
      path: "/:pathMatch(.*)", 
      name: "NotFound",
      component: NotFound 
    }
  ]
});
